import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1f6d1f6b: FaireBrandEntity = {
  token: "b_1f6d1f6b",
  type: "brand",
  name: "Vinylux",
  avatarUrl: "https://cdn.faire.com/fastly/b06ddcef915361a8b8dde7a362d8f62619aa7b934600d4f5507091e59114130e.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/3ce77f87d86f32b2bd0bd8d779751cc89553e848786cafe4c6ff98ffb1d7fe68.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/b06ddcef915361a8b8dde7a362d8f62619aa7b934600d4f5507091e59114130e.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/3ce77f87d86f32b2bd0bd8d779751cc89553e848786cafe4c6ff98ffb1d7fe68.jpeg",
  location: "PHILADELPHIA, PA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 151,
  isTopShop: true,
  isInsider: true,
  description: "At Vinylux, we transform vintage records into a suite of handmade, upcycled products - bringing new life to vintage vinyl! \nOur designs at Vinylux preserve the look and feel of the old records, including the original labels, while creating new useful, elegant objects. We get our supply of recycled vinyl from record shops, dealers, and sometimes from people's attics! Every year, we recycle and reuse approximately 250,000 records. Vinylux is committed to being eco-friendly and having energy efficient manufacturing - we complete the majority of of the production process in our Philadelphia studio!\nWe hope you enjoy our Vintage Vinyl Record Products!",
  meta: {
    source: "api",
    importedAt: "2026-10-07T18:32:29.581Z",
    importedBy: "entity-db-cli"
  }
};
